import axios from "utils/axios";
import retryAxios from "utils/retryAxios";

class ApiService {
  signIn({ email, password }) {
    const url = "/auth/sign_in";
    return axios.post(url, { session: { email, password } });
  }

  getHistoryChats() {
    const url = `/chats/history`;
    return axios.get(url);
  }

  getArchivedHistoryChats() {
    const url = `/chats/history?type=archived`;
    return axios.get(url);
  }

  getWorkSessionHistoryChats() {
    const url = `/chats/work_session_history`;
    return axios.get(url);
  }

  getTrialHistoryChats() {
    const url = `/chats/trial_rooms_history`;
    return axios.get(url);
  }

  sendMessage(chatId, body) {
    const url = `/chats/${chatId}/messages`;
    return axios.post(url, { body });
  }

  getMessages = (chatId, offset = 0, limit = 0) => {
    const url = `/chats/${chatId}/messages?offset=${offset}&limit=${limit}`;
    return axios.get(url);
  };

  getTarots() {
    const url = `/tarots`;
    return axios.get(url);
  }

  addTrialMinutes(chatId, minutes = 3) {
    const url = `/chats/${chatId}/add_trial_minutes`;
    return axios.post(url, { minutes });
  }

  getPremiumPurchasesByConsultant(consultantId) {
    const url = `/premium_purchases?consultant_id=${consultantId}`;
    return axios.get(url);
  }

  updatePremiumPurchase(contactId, premiumPurchaseId, body) {
    const url = `/contacts/${contactId}/premium_purchases/${premiumPurchaseId}`;
    return axios.patch(url, { body });
  }

  createNote(contactId, body) {
    const url = `/contacts/${contactId}/notes`;
    return axios.post(url, { body });
  }

  updateNote(contactId, noteId, body) {
    const url = `/contacts/${contactId}/notes/${noteId}`;
    return axios.patch(url, { body });
  }

  deleteNote(contactId, noteId) {
    const url = `/contacts/${contactId}/notes/${noteId}`;
    return axios.delete(url);
  }

  getProfile() {
    const url = `/profile`;
    return axios.get(url);
  }

  getReport(id) {
    const url = `/reports/${id}`;
    return axios.get(url);
  }

  updateReport(id, body) {
    const url = `/reports/${id}`;
    return axios.patch(url, { body });
  }

  createReport() {
    const url = `/reports`;
    return axios.post(url);
  }

  getCurrentWorkSession() {
    const url = "/work_sessions/current";
    return axios.get(url);
  }

  getUser() {
    const url = "/me";
    return axios.get(url);
  }

  createWorkSession() {
    const url = "/work_sessions";
    return axios.post(url);
  }

  updateWorkSession(id) {
    const url = `/work_sessions/${id}`;
    return axios.patch(url);
  }

  updateNotificationToken(notification_token) {
    const url = "/notification_token";
    return axios.patch(url, { body: { notification_token } });
  }

  getPremiumPurchases(contactId) {
    const url = `/contacts/${contactId}/premium_purchases`;
    return retryAxios.get(url);
  }

  getNotes(contactId) {
    const url = `/contacts/${contactId}/notes`;
    return retryAxios.get(url);
  }

  getPhotos(contactId) {
    const url = `/contacts/${contactId}/photos`;
    return retryAxios.get(url);
  }

  getTags() {
    const url = "/chats/tags";
    return axios.get(url);
  }

  createOrUpdateTag(body) {
    const url = "/chats/tags";
    return axios.post(url, { body });
  }

  deleteTag(tagId) {
    const url = `/chats/tags/${tagId}`;
    return axios.delete(url);
  }
}

export default new ApiService();
